import PropTypes from "prop-types";

const SubHeader = (props) => {
  const {
    value = '',
  } = props;
  return (
    <>
      <div
        className="sub-header"
        dangerouslySetInnerHTML={{ __html: value }}
        id={`${props.type}-${props.index}`}
      />
      <style jsx global>
        {`
          .sub-header p {
            font-size: 24px;
            font-weight: bold;
            line-height: 34px;
            margin-bottom: 0;
            color: #000;
            font-weight: bold;
            margin-bottom: 5px;
          }
        `}
      </style>
    </>
  );
};

SubHeader.propTypes = {
  value: PropTypes.string,
};

export default SubHeader;
